export const tooManyAttemptsPhoneNumber = '6666666666';
